// Дерево площадок размещения в окне настройки критерия (SCR-CL-01.3, блок «Дерево площадок»).
// Сервер строит дерево, состояния и порядок узлов при открытии окна (EV-1 шаг 7);
// здесь — события EV-4 (отметка), EV-5 (раскрытие) и EV-6 (поиск). Порядок узлов не меняется.
// Значение критерия собирают только чекбоксы площадок (name="values[]"), узлы стран и
// макро-регионов имени не имеют и не постятся.
class ExchangeTreeScreenerCriteria extends Tango.Component {
    widgetDidMount() { this._bind(); }
    widgetContentChanged() { this._bind(); }

    _bind() {
        const root = document.getElementById(this.root);
        if (!root || root.dataset.vtreeBound) return;
        root.dataset.vtreeBound = '1';

        const tree = root.querySelector('.vtree');
        const search = root.querySelector('.sos-search');
        if (!tree || !search) return;

        const nodes = [...tree.querySelectorAll('li.vtree-node')].map(li => {
            const row = li.querySelector(':scope > .vtree-row');
            const input = row.querySelector('input[type=checkbox]');
            const textSpans = [...row.querySelectorAll('.sos-code, .sos-text')]
                .map(span => ({ span, text: span.textContent.trim() }));
            return {
                li, input,
                isRoot: li.classList.contains('vtree-root'),
                children: li.querySelector(':scope > ul'),
                textSpans,
                lower: textSpans.map(t => t.text.toLowerCase()).join(' ')
            };
        });
        const byLi = new Map(nodes.map(n => [n.li, n]));
        const roots = nodes.filter(n => n.isRoot);
        const childNodes = n => n.children ? [...n.children.children].map(li => byLi.get(li)).filter(Boolean) : [];
        const parentOf = n => { const p = n.li.parentElement.closest('li.vtree-node'); return p ? byLi.get(p) : null; };

        const applyState = (n, state) => {
            n.li.dataset.state = state;
            n.input.indeterminate = state === 'partial';
            n.input.checked = state === 'checked';
        };
        nodes.forEach(n => { if (n.li.dataset.state === 'partial') n.input.indeterminate = true; });

        const setExpanded = (n, expanded) => n.li.classList.toggle('collapsed', !expanded);
        const isExpanded = n => !n.li.classList.contains('collapsed');
        const searching = () => search.value.trim() !== '';

        // EV-4. Отметка узла: каскад на все вложенные (включая скрытые поиском),
        // пересчёт состояния родителей до корня; порядок не меняется.
        const cascade = (n, checked) => {
            applyState(n, checked ? 'checked' : 'unchecked');
            childNodes(n).forEach(c => cascade(c, checked));
        };
        const recompute = n => {
            const kids = childNodes(n);
            if (!kids.length) return;
            const states = kids.map(k => k.li.dataset.state);
            const all = states.every(s => s === 'checked');
            const none = states.every(s => s === 'unchecked');
            applyState(n, all ? 'checked' : none ? 'unchecked' : 'partial');
        };
        tree.addEventListener('change', e => {
            const n = byLi.get(e.target.closest('li.vtree-node'));
            if (!n || e.target !== n.input) return;
            // Клик по частично отмеченному узлу браузер переводит в «отмечен» → отметить целиком.
            cascade(n, n.input.checked);
            for (let p = parentOf(n); p; p = parentOf(p)) recompute(p);
        });

        // EV-5. Раскрытие: корневые узлы — аккордеоном при пустом поиске; иначе — только сам узел.
        tree.addEventListener('click', e => {
            const toggle = e.target.closest('.vtree-toggle');
            if (!toggle) return;
            const n = byLi.get(toggle.closest('li.vtree-node'));
            if (!n || !n.children) return;
            if (n.isRoot && !searching()) {
                const open = !isExpanded(n);
                roots.forEach(r => setExpanded(r, false));
                setExpanded(n, open);
            } else {
                setExpanded(n, !isExpanded(n));
            }
        });

        // EV-6. Поиск по подстроке названия или кода площадки: найденные узлы показываются
        // с родителями и всеми вложенными узлами в раскрытом виде; аккордеон не действует;
        // пустой результат — пустое дерево. Очистка — полное дерево, корни свёрнуты.
        let nestedSnapshot = null;
        const renderText = (n, q) => {
            for (const t of n.textSpans) {
                const idx = q ? t.text.toLowerCase().indexOf(q) : -1;
                if (idx < 0) { t.span.textContent = t.text; continue; }
                const mark = document.createElement('mark');
                mark.textContent = t.text.slice(idx, idx + q.length);
                t.span.textContent = '';
                t.span.append(
                    document.createTextNode(t.text.slice(0, idx)),
                    mark,
                    document.createTextNode(t.text.slice(idx + q.length)));
            }
        };
        const filter = (n, q, ancestorMatched) => {
            const self = n.lower.indexOf(q) >= 0;
            let descendant = false;
            for (const c of childNodes(n))
                descendant = filter(c, q, ancestorMatched || self) || descendant;
            const visible = self || ancestorMatched || descendant;
            n.li.style.display = visible ? '' : 'none';
            if (visible && n.children) setExpanded(n, true);
            renderText(n, self ? q : '');
            return self || descendant;
        };
        search.addEventListener('input', () => {
            const q = search.value.trim().toLowerCase();
            if (!q) {
                nodes.forEach(n => { n.li.style.display = ''; renderText(n, ''); });
                if (nestedSnapshot) {
                    nodes.forEach(n => { if (!n.isRoot && n.children) setExpanded(n, nestedSnapshot.get(n)); });
                    nestedSnapshot = null;
                }
                roots.forEach(r => setExpanded(r, false));
                return;
            }
            if (!nestedSnapshot)
                nestedSnapshot = new Map(nodes.filter(n => !n.isRoot && n.children).map(n => [n, isExpanded(n)]));
            roots.forEach(r => filter(r, q, false));
        });

        search.focus();
    }
}

Tango.registerComponent(ExchangeTreeScreenerCriteria);
